import { SortDirection } from '@tanstack/react-table';
import { twMerge } from 'tailwind-merge';

/** Modified version of Hero Icon's ArrowsUpDownIcon. In the version exported
 * from @heroicons/react the two arrows are in the same svg path, so there's no
 * way to style each arrow independently.
 *
 * Copyright (c) Tailwind Labs, Inc. License:
 * https://github.com/tailwindlabs/heroicons/blob/master/LICENSE
 */
export const SortIcon = ({
  sortDirection,
  className,
}: {
  sortDirection: SortDirection | undefined;
  className?: string;
}) => {
  const getArrowClasses = (direction: SortDirection) => {
    return twMerge(
      'fill-contentSecondary',
      sortDirection === direction && 'fill-contentPrimary', // Active state
      sortDirection && sortDirection !== direction && 'opacity-25' // Inactive state when sorting
    );
  };

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge('size-3', className)}
    >
      {/* Down arrow */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        className={getArrowClasses('desc')}
        d="M13.7803 10.4697C14.0732 10.7626 14.0732 11.2374 13.7803 11.5303L11.5303 13.7803C11.2374 14.0732 10.7626 14.0732 10.4697 13.7803L8.21967 11.5303C7.92678 11.2374 7.92678 10.7626 8.21967 10.4697C8.51256 10.1768 8.98744 10.1768 9.28033 10.4697L10.25 11.4393V5.75C10.25 5.33579 10.5858 5 11 5C11.4142 5 11.75 5.33579 11.75 5.75V11.4393L12.7197 10.4697C13.0126 10.1768 13.4874 10.1768 13.7803 10.4697Z"
      />

      {/* Up arrow */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        className={getArrowClasses('asc')}
        d="M2.21967 5.53033C1.92678 5.23744 1.92678 4.76256 2.21967 4.46967L4.46967 2.21967C4.76256 1.92678 5.23744 1.92678 5.53033 2.21967L7.78033 4.46967C8.07322 4.76256 8.07322 5.23744 7.78033 5.53033C7.48744 5.82322 7.01256 5.82322 6.71967 5.53033L5.75 4.56066L5.75 10.25C5.75 10.6642 5.41421 11 5 11C4.58579 11 4.25 10.6642 4.25 10.25L4.25 4.56066L3.28033 5.53033C2.98744 5.82322 2.51256 5.82322 2.21967 5.53033Z"
      />
    </svg>
  );
};
